<template>
  <div class="bg-white">
    <div class="py-24 relative">
      <!-- <div class="md:flex w-full relative top106"> -->
      <div class="md:w-1/4 w-full left-0 md:fixed px-4 mb-8 bg-white">
        <div class="w-full">
          <CourseIndex :selectedCourse="selectedCourse" />
        </div>
      </div>
      <div
        class="
          md:w-3/4
          w-full
          md:absolute
          right-0
          md:pr-4
          px-4
          md:px-0
          bg-white
        "
      >
        <div class="w-full bg-white">
          <Screen :selectedCourse="selectedCourse" />
          <Overview :selectedCourse="selectedCourse" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "./../scss/index.scss";
import Screen from "./components/Screen.vue";
import CourseIndex from "./components/CourseIndex.vue";
import Overview from "./components/Overview.vue";
import { mapState } from "vuex";
// import  from "./components/.vue";
// import  from "./components/Reviews.vue";
export default {
  data() {
    return {};
  },
  components: {
    Screen,
    CourseIndex,
    Overview,
  },

  computed: {
    ...mapState("eLearning", ["selectedCourse"]),
  },
};
</script>
